// extracted by mini-css-extract-plugin
module.exports = {"loader":"Button_loader__1gqyy","spin":"Button_spin__2pA1Q","button":"Button_button__Nfhxt","outlineButton":"Button_outlineButton__7RCQ-"};